import styled from 'styled-components'

export const TextFieldStyled = styled.input<{ uppercase?: boolean }>`
  border: 1px solid ${({ theme }) => theme.inputBorderColour};
  border-radius: ${({ theme }) => theme.formControlBorderRadius};
  padding: 0 ${({ theme }) => theme.formControlHorizontalPadding};
  color: ${({ theme }) => theme.primaryTextColour};
  font-size: ${({ theme }) => theme.generalFontSize};
  height: 50px;
  width: 100%;
  font-family: ${({ theme }) => theme.inputFontFamily};
  font-style: ${({ theme }) => theme.fontStyle};
  font-weight: ${({ theme }) => theme.fontWeight};
  text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : null)};
  box-sizing: border-box;

  @media (min-width: 768px) {
    height: 60px;
  }

  :hover:not(:disabled),
  :where(.hover):not(:disabled) {
    outline: 2px solid ${({ theme }) => theme.inputHoverOutlineColour};
  }

  :active:not(:disabled),
  :where(.active):not(:disabled) {
    border-color: ${({ theme }) => theme.inputActiveBorderColour};
  }
  :focus:not(:disabled),
  :where(.focus):not(:disabled) {
    outline-offset: 0px;
    outline: 2px solid ${({ theme }) => theme.inputFocusOutlineColour};
    border-color: ${({ theme }) => theme.inputFocusBorderColour};
  }
  :active:focus,
  :where(.focus.active):not(:disabled) {
    outline: 1px solid ${({ theme }) => theme.inputActiveFocusOutlineColour};
  }
  ::-ms-clear {
    display: none;
  }
  ::placeholder {
    text-transform: none;
    color: ${(props) => props.theme.secondaryTextColour};
  }
`

export const TextFieldWIthIcon = styled(TextFieldStyled)`
  padding-left: 50px;
`
